export const cardBase = {
  backgroundColor: '#FFFFFF',
  borderRadius: '10px',
  boxShadow: '0px 0px 10px 1px rgba(0, 0, 0, 0.1)',
} as const;

export const text = {
  // Common muted body text
  body14Muted: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '1.219em',
    color: 'rgba(0, 0, 0, 0.6)',
  },
  // 12px body text
  body12: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '15px',
    color: '#000000',
  },
  body12Medium: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '15px',
    color: '#000000',
  },
  // Common title
  title24: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '1.219em',
    color: '#000000',
  },
} as const;

export const brand = {
  purpleAccent: '#661595',
  purpleAccentDark: '#551280',
  greenPrimary: '#79C303',
  greenPrimaryDark: '#6BA302',
  redAlert: '#F80303',
} as const;

export const palette = {
  mutedText: 'rgba(0, 0, 0, 0.6)'
} as const;

export const alpha = {
  purple60: 'rgba(102, 21, 149, 0.6)',
  purple05: 'rgba(102, 21, 149, 0.05)',
  purple100: 'rgba(102, 21, 149, 1)',
  purpleLight40: 'rgba(153, 102, 204, 0.4)',
  green10: 'rgba(121, 195, 3, 0.1)',
  green100: 'rgba(121, 195, 3, 1)',
  green12: 'rgba(121, 195, 3, 0.12)',
  green20: 'rgba(121, 195, 3, 0.2)',
  purple12: 'rgba(102, 21, 149, 0.12)',
  red10: 'rgba(248, 3, 3, 0.1)',
  red30: 'rgba(248, 3, 3, 0.3)',
} as const;

export const gradients = {
  brandLinear: `linear-gradient(90deg, ${alpha.green100} 40%, ${alpha.purple100} 60%)`,
} as const;

export const radials = {
  greenSoft: 'radial-gradient(circle, rgba(121, 195, 3, 0.12) 0%, rgba(121, 195, 3, 0) 60%)',
  purpleSoft: 'radial-gradient(circle, rgba(102, 21, 149, 0.12) 0%, rgba(102, 21, 149, 0) 60%)',
} as const;
